import { createContext, useContext, useState } from 'react'
import { ThemeType, ColorType } from '../types'

export const themes = {
  dark: {
    background: '#10151e',
    main: '#6287a5',
    second: '#6E7DAB',
    highlight: '#ddbb2f',
    light: '#c5d0dd',
  },
  light: {
    background: '#dae2ec',
    main: '#364268',
    second: '#4d6f91',
    highlight: '#10151e',
    light: '#10151e',
  },
}
type ThemeContextType = {
  theme: ThemeType
  colors: ColorType
  toggleTheme: () => void
}
const ThemeContext = createContext<ThemeContextType>({
  theme: 'dark',
  colors: themes.dark,
  toggleTheme: () => {},
})
export const ThemeContextProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [theme, setTheme] = useState<ThemeType>('dark')

  const toggleTheme = () => {
    setTheme(t => (t === 'light' ? 'dark' : 'light'))
  }

  return (
    <ThemeContext.Provider
      value={{ theme, colors: themes[theme], toggleTheme }}
    >
      {children}
    </ThemeContext.Provider>
  )
}
export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) throw new Error('useTheme must be used inside ThemeProvider')
  return context
}
